<template>
  <div class="shopping_cart_box bar_content_box" id="shopping_cart_box">
    <div class="content_title fix">
      <div class="f-fl font_color">
        <i class="detail_ico_25 shopping_cart_ico"
          ><img
            class="shoppingcart_ico"
            src="https://resource.rcclchina.com.cn/tui2/detail/shoppingcart.png"
        /></i>
        购物车
      </div>
      <div class="f-fr" id="close_btn" @click="closeMenu">
        <i role="button" class="detail_ico_25 close_block_ico">
          <img src="https://resource.rcclchina.com.cn/tui2/detail/close.png"
        /></i>
      </div>
    </div>

    <div class="shoppingcart_cruise clearfix">
      <div
        class="cruise_title homeport_cruise"
        :class="{ cruise_bottom_border: isShowHp }"
        @click="isShowHp = true"
      >
        <span>中国出发航线</span>
        <i class="cruise-tab-badge" v-show="hpShoppingCartCount > 0">{{
          hpShoppingCartCount
        }}</i>
      </div>
      <div
        class="cruise_title tui_cruise"
        :class="{ cruise_bottom_border: !isShowHp }"
        @click="isShowHp = false"
      >
        <span>海外出发航线</span>
        <i class="cruise-tab-badge" v-show="rowShoppingCartCount > 0">{{
          rowShoppingCartCount
        }}</i>
      </div>
    </div>

    <div
      class="shopping_cart_list content_box"
      v-if="cruiseShoppingCarts.length > 0"
    >
      <ShoppingCartCruise
        v-for="(cruiseShoppingCart, i) in cruiseShoppingCarts"
        :key="'cruise_' + i"
        :shoppingCarts="cruiseShoppingCart.shoppingCarts"
        :selectedShoppingCarts="
          getSelectShoppingCartsByCruise(
            cruiseShoppingCart.cruise.shipCode,
            cruiseShoppingCart.cruise.sailDate
          )
        "
        :onCruiseSelected="onCruiseSelected"
        :onStateroomSelected="onStateroomSelected"
        :onConnectRoomSelected="onConnectRoomSelected"
        :onAddShoppingCart="onAddShoppingCart"
        :onDeleteShoppingCart="onDeleteShoppingCart"
        :onDeleteConnectRoom="onDeleteConnectRoom"
        :onDeleteByStateroom="onDeleteByStateroom"
        :onDeleteCruiseClicked="onDeleteCruiseClicked"
        :showConnectRoomPopup="showConnectRoomPopup"
        :showQiaohuPopup="showQiaohuPopup"
      />
    </div>

    <!--购物车为空提示-->
    <div class="shopping_cart_isnull" v-else>
      <img
        src="https://resource.rcclchina.com.cn/tui2/detail/shopping_cart.png"
        alt=""
      />
      <div class="tips_text">
        你的购物车还是空的~这怎么能行，快来添加您的美好旅行计划吧
      </div>
      <a @click="goCruiseSearch" class="link_btn noCruise"
        >搜索及添加心仪航线</a
      >
    </div>

    <div class="totle_box fix" v-show="selectShoppingCarts.length > 0">
      <div class="f-fl check_num">
        已选
        <span class="curStateroomCount">{{ selectShoppingCarts.length }}</span>
        间
      </div>
      <div class="f-fr check_price">
        总计：<span
          ><em>￥</em><span class="curTotalPrice">{{ totalAmount }}</span></span
        >
      </div>
    </div>

    <SubmitShoppingCartButton
      class="bottom_btn"
      id="shoppingCart_NextButton"
      v-show="selectShoppingCarts.length > 0"
      :shoppingCarts="selectShoppingCarts"
      :isRow="!isShowHp"
      :buttonName="buttonName"
    />

    <ConnectRoomPopup
      v-on:onModalClose="closeConnectRoomPopup"
      :isShow="isShowConnectRoomPopup"
    />

    <QiaohuPopup
      :shipCode="targetQiaohu.shipCode"
      :sailDate="targetQiaohu.sailDate"
      v-on:onModalClose="closeQiaohuPopup"
      :isShow="isShowQiaohuPopup"
    />
  </div>
</template>

<script>
import api from "@/api";
import _ from "lodash";
import { gioTracking } from "@/utilities/tools";
const ShoppingCartCruise = () =>
  import("@/components/FloatMenu/ShoppingCartCruise.vue");
const SubmitShoppingCartButton = () =>
  import("@/components/Cruise/CruiseDetail/SubmitShoppingCartButton.vue");
const ConnectRoomPopup = () =>
  import("@/components/Cruise/CruiseDetail/ConnectRoomPopup.vue");
const QiaohuPopup = () =>
  import("@/components/Cruise/CruiseDetail/QiaohuPopup.vue");
export default {
  name: "FloatMenuShoppingCart",
  components: {
    ShoppingCartCruise,
    SubmitShoppingCartButton,
    ConnectRoomPopup,
    QiaohuPopup,
  },
  props: {
    closeMenu: {
      type: Function,
    },
  },
  data() {
    return {
      selectShoppingCarts: [],
      isShowHp: true,
      isShowQiaohuPopup: false,
      isShowConnectRoomPopup: false,
      targetQiaohu: {
        shipCode: "",
        sailDate: "",
      },
    };
  },
  methods: {
    goCruiseSearch() {
      if (this.isShowHp) {
        return (location.href =
          process.env.VUE_APP_BASE_URL + "/Rccl.Cruise/CruiseSearch/Search");
      } else {
        return (location.href = process.env.VUE_APP_TUI_URL + "/Cruise/Search");
      }
    },
    getSelectShoppingCartsByCruise(shipCode, sailDate) {
      return this.selectShoppingCarts.filter(
        (r) => r.shipCode == shipCode && r.sailDate == sailDate
      );
    },
    getShoppingCart() {
      this.$loading.show();
      this.$store.dispatch("GET_SHOPPING_CART");
    },
    // 选择航线，如果之前都选中了，就反选，其他情况都选中
    onCruiseSelected(shoppingCarts) {
      if (!shoppingCarts || shoppingCarts.length == 0) return;
      const cruiseId = shoppingCarts[0].cruiseId;
      const selected = this.selectShoppingCarts.filter(
        (r) => r.cruiseId == cruiseId
      );
      if (shoppingCarts.length == selected.length) {
        // 反选
        this.selectShoppingCarts = [];
      } else {
        this.selectShoppingCarts = [];
        shoppingCarts.forEach((shoppingCart) => {
          this.selectShoppingCarts.push(shoppingCart);
        });
				gioTracking('track','evt_CartBoxChecked')
      }
    },
    // 选择舱房，如果有选中就删除，没有就选中，并反选其他航线的
    onStateroomSelected(shoppingCarts) {
      if (shoppingCarts.length == 0) return;
      const shoppingCart = shoppingCarts[0];
			let alreadyIn = this.selectShoppingCarts.some(
				(r) =>
					r.cruiseId == shoppingCart.cruiseId &&
					r.berthedCategoryCode == shoppingCart.berthedCategoryCode &&
					r.isnrp == shoppingCart.isnrp
			);
      if (alreadyIn) {
				// 反选
        this.selectShoppingCarts = this.selectShoppingCarts.filter(
          (r) =>
            !(
              r.cruiseId == shoppingCart.cruiseId &&
              r.berthedCategoryCode == shoppingCart.berthedCategoryCode &&
              r.isnrp == shoppingCart.isnrp
            )
        );
      } else {
        this.selectShoppingCarts = this.selectShoppingCarts.filter(
          (r) => r.cruiseId == shoppingCart.cruiseId
        );
        this.selectShoppingCarts = this.selectShoppingCarts.concat(
          shoppingCarts
        );
				gioTracking('track','evt_CartBoxChecked')
      }
    },
    // 选择连通房
    onConnectRoomSelected(connectId, cruiseId) {
      if (this.selectShoppingCarts.some((r) => r.connectId == connectId)) {
				// 反选
        this.selectShoppingCarts = this.selectShoppingCarts.filter(
          (r) => r.connectId != connectId
        );
      } else {
        this.selectShoppingCarts = this.selectShoppingCarts.filter(
          (r) => r.cruiseId == cruiseId
        );
        const shoppingCarts = this.shoppingCarts.filter(
          (r) => r.connectId == connectId
        );
        this.selectShoppingCarts = this.selectShoppingCarts.concat(
          shoppingCarts
        );
				gioTracking('track','evt_CartBoxChecked')
      }
    },
    // 点击加号添加购物车
    async onAddShoppingCart(shoppingCart) {
      let requestData = {
        viewModel: {
          shipCode: shoppingCart.shipCode,
          sailDate: shoppingCart.sailDate,
          productPackageId: -1,
          packageId: shoppingCart.packageId,
          stateroomCategoryCode: shoppingCart.berthedCategoryCode,
          stateroomClass: shoppingCart.stateroomType,
          fareCode: shoppingCart.fareCode,
          guestNumber: shoppingCart.guestNumber,
          originAmount: shoppingCart.originAmount,
          netAmount: shoppingCart.netAmount,
          isNrp: shoppingCart.isnrp,
          groupAgencyId: shoppingCart.groupAgencyId || "",
          groupAgencyName: shoppingCart.agencyName || "",
          requestsequence: shoppingCart.requestSequence || "",
          groupType: shoppingCart.groupType || "",
          groupId: shoppingCart.groupId || "",
          connectId: "",
        },
      };
      this.$loading.show();
      const { success, data, errMsg } = await api.booking.addShoppingCart(
        requestData
      );
      this.$loading.hide();
      if (!success) {
        this.$alert.show(errMsg);
        return;
      }
      let newShoppingCart = _.cloneDeep(shoppingCart);
      newShoppingCart.shoppingCartId = data.shoppingCartId;
      this.shoppingCarts.push(newShoppingCart);
      this.getShoppingCart();

      // 检查舱房是否已经被选中，选中的话还需要push到selectShoppingCart里面
      if (
        this.selectShoppingCarts.some(
          (r) =>
            r.cruiseId == newShoppingCart.cruiseId &&
            r.berthedCategoryCode == newShoppingCart.berthedCategoryCode &&
            r.isnrp == newShoppingCart.isnrp
        )
      ) {
        this.selectShoppingCarts.push(newShoppingCart);
      }

      try {
        if (window && window.gio) {
          if (requestData.viewModel.isNrp) {
            window.gio("track", "NRP_BF01");
          }
          gioTracking("track", "evt_CartAddRoom", {
            GuestNumber: requestData.viewModel.guestNumber,
            RoomClass: requestData.viewModel.stateroomClass,
            RoomCategory: requestData.viewModel.stateroomCategoryCode,
						RoomType: requestData.viewModel.groupType == "QIAOHU" ? 'Qiaohu' : 'nil'
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    // 减号删除舱房
    async onDeleteShoppingCart(shoppingCart) {
      const requestData = this.getShoppingCartRequest(shoppingCart);
      await this.callDeleteShoppingCartApi(
        requestData,
        shoppingCart.shoppingCartId
      );
    },
    async onDeleteCruiseShoppingCart(shoppingCart) {
      const requestData = {
        viewModel: shoppingCart,
      };
      await this.callDeleteShoppingCartApi(
        requestData,
        shoppingCart.shoppingCartId
      );
    },
    async callDeleteShoppingCartApi(requestData) {
      this.$loading.show();
      const { success, errMsg } = await api.booking.deleteShoppingCart(
        requestData
      );
      this.$loading.hide();
      if (!success) {
        this.$alert.show(errMsg);
        return;
      }
      this.getShoppingCart();
    },
    getShoppingCartRequest(shoppingCart) {
      const requestData = {
        viewModel: {
          shipCode: shoppingCart.shipCode,
          sailDate: shoppingCart.sailDate,
          productPackageId: -1,
          packageId: shoppingCart.packageId,
          stateroomCategoryCode: shoppingCart.berthedCategoryCode,
          stateroomClass: shoppingCart.stateroomType,
          fareCode: shoppingCart.fareCode,
          guestNumber: shoppingCart.guestNumber,
          originAmount: shoppingCart.originAmount,
          netAmount: shoppingCart.netAmount,
          isNrp: shoppingCart.isnrp,
          groupAgencyId: shoppingCart.groupAgencyId || "",
          groupAgencyName: shoppingCart.agencyName || "",
          requestsequence: shoppingCart.requestSequence || "",
          groupType: shoppingCart.groupType || "",
          groupId: shoppingCart.groupId || "",
          connectId: shoppingCart.connectId || "",
        },
      };
      return requestData;
    },
    // 删除连通房
    async onDeleteConnectRoom(connectId) {
      const connectRooms = this.shoppingCarts.filter(
        (r) => r.connectId == connectId
      );
      if (!connectRooms || connectRooms.length == 0) return;
      await this.onDeleteCruiseShoppingCart({
        connectId,
        guestNumber: connectRooms[0].guestNumber,
        shipCode: connectRooms[0].shipCode,
        sailDate: connectRooms[0].sailDate,
        stateroomCategoryCode: connectRooms[0].berthedCategoryCode,
      });
    },
    // 删除多间舱房
    async onDeleteByStateroom(shoppingCarts) {
      this.$loading.show();
      for (let i = 0; i < shoppingCarts.length; i++) {
        const requestData = this.getShoppingCartRequest(shoppingCarts[i]);
        const { success, errMsg } = await api.booking.deleteShoppingCart(
          requestData
        );
        if (!success) {
          this.$alert.show(errMsg);
          this.$loading.hide();
          return;
        }
      }
      this.$loading.hide();
      this.getShoppingCart(false);
    },
    // 删除购物车，并添加心愿单
    async onDeleteCruiseClicked(shipCode, sailDate, packageId, cruiseId) {
      this.$loading.show();
      const deleteCruise = {
        viewModel: {
          shipCode: shipCode,
          sailDate: sailDate,
          packageId: packageId,
          productPackageId: -1,
        },
      };
      const { success, errMsg } = await api.booking.deleteShoppingCartCruise(
        deleteCruise
      );
      if (!success) {
        this.$loading.hide();
        this.$alert.show(errMsg);
        return;
      }
      this.$loading.hide();
      this.addWishList(cruiseId);
      this.getShoppingCart(false);
    },
    // 添加心愿单
    async addWishList(cruiseId) {
      this.$loading.show();
      const requestData = {
        cruiseId: cruiseId,
        source: "PC",
      };
      await api.cruise.addWishList(requestData);
      this.$loading.hide();
    },
    showQiaohuPopup(shipCode, sailDate) {
      this.targetQiaohu = { shipCode, sailDate };
      this.isShowQiaohuPopup = true;
      this.showPopup();
    },
    closeQiaohuPopup() {
      this.isShowQiaohuPopup = false;
    },
    showConnectRoomPopup() {
      this.isShowConnectRoomPopup = true;
      this.showPopup();
    },
    closeConnectRoomPopup() {
      this.isShowConnectRoomPopup = false;
    },
    showPopup() {
      history.pushState({ page: "shoppingCart" }, null);
    },
    pageScrollHandler(scrollTop) {
      if (scrollTop > 110) {
        this.isNavFixed = true;
      } else {
        this.isNavFixed = false;
      }
    },
  },
  computed: {
    shoppingCarts() {
      let bookings = this.$store.state.booking.shoppingCarts || [];
      let shoppingCarts = bookings;
      // 默认第一条航线自动选中，如果url上带有shipCode,saildate，那先把这条航线购物车放到最顶端，再默认选中
      if (
        this.shipCode &&
        this.shipCode.length > 0 &&
        this.sailDate &&
        this.sailDate.length > 0
      ) {
        let lists = shoppingCarts.filter(
          (r) => r.shipCode == this.shipCode && r.sailDate == this.sailDate
        );
        if (lists && lists.length > 0) {
          shoppingCarts = shoppingCarts.filter(
            (r) => !(r.shipCode == this.shipCode && r.sailDate == this.sailDate)
          );
          shoppingCarts = lists.concat(shoppingCarts);
        }
      }
      if (this.isShowHp) {
        shoppingCarts = shoppingCarts.filter(
          (r) => r.cruisePartRecord && !r.cruisePartRecord.isRow
        );
      } else {
        shoppingCarts = shoppingCarts.filter(
          (r) => r.cruisePartRecord && r.cruisePartRecord.isRow
        );
      }
      return shoppingCarts;
    },
    hpShoppingCartCount() {
      return this.$store.state.booking.hpShoppingCartCount || 0;
    },
    rowShoppingCartCount() {
      return this.$store.state.booking.rowShoppingCartCount || 0;
    },
    // 将购物车按照航线切分
    cruiseShoppingCarts() {
      let cruises = [];
      this.shoppingCarts.forEach((shoppingCart) => {
        let cruise = cruises.filter(
          (r) =>
            r.cruise.shipCode == shoppingCart.shipCode &&
            r.cruise.sailDate == shoppingCart.sailDate
        );
        if (cruise.length > 0) {
          cruise[0].shoppingCarts.push(shoppingCart);
        } else {
          cruises.push({
            cruise: {
              shipCode: shoppingCart.shipCode,
              sailDate: shoppingCart.sailDate,
            },
            shoppingCarts: [shoppingCart],
          });
        }
      });
      return cruises;
    },
    selectedCruise() {
      if (this.selectShoppingCarts.length == 0) {
        return {};
      }
      return this.selectShoppingCarts[0];
    },
    rowShoppingCartLink() {
      const rowLink = `${process.env.VUE_APP_TUI_URL}/Booking/MobileShoppingCart`;
      return `${
        process.env.VUE_APP_BASE_URL
      }/Rccl.Campaign/RedirectToTui?redirectUrl=${encodeURIComponent(rowLink)}`;
    },
    shipCode() {
      const cruiseDetail = this.$store.state.cruise.cruiseDetail.data;
      if (cruiseDetail) {
        return cruiseDetail.shipCode;
      }
      return "";
    },
    sailDate() {
      const cruiseDetail = this.$store.state.cruise.cruiseDetail.data;
      if (cruiseDetail) {
        return cruiseDetail.sailDate;
      }
      return "";
    },
    totalAmount() {
      let amount = 0;
      this.selectShoppingCarts.forEach((shoppingCart) => {
        amount += shoppingCart.amount;
      });
      return amount.toFixed("0");
    },
    buttonName() {
      return this.isShowHp ? "下一步 乘客信息" : "详询4008207195";
    },
  },
  watch: {
    shoppingCarts(shoppingCarts) {
      if (shoppingCarts.length > 0) {
        if (
          this.shipCode &&
          this.shipCode.length > 0 &&
          this.sailDate &&
          this.sailDate.length > 0
        ) {
          const cruiseShoppingCarts = shoppingCarts.filter(
            (r) => r.shipCode == this.shipCode && r.sailDate == this.sailDate
          );
          if (cruiseShoppingCarts.length > 0) {
            this.selectShoppingCarts = cruiseShoppingCarts;
          }
        }
        // const firstCruiseId = shoppingCarts[0].cruiseId
        // const firstCruiseShoppingCarts = shoppingCarts.filter(r=>r.cruiseId == firstCruiseId)
        // this.selectShoppingCarts = firstCruiseShoppingCarts
      }
      // 刷新购物车之后，如果已选择的购物车已经被删除，需要反选
      const shoppingCartIds = shoppingCarts.map((r) => r.shoppingCartId);
      this.selectShoppingCarts = this.selectShoppingCarts.filter((r) =>
        shoppingCartIds.some((sc) => sc == r.shoppingCartId)
      );
      this.$loading.hide();
    },
  },
};
</script>

<style lang="less" scoped>
.bar_content_box {
  position: relative;
  height: 100%;
  overflow: initial;
  padding: 40px 0px;
  background-color: white;
  .content_title {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    font-size: 16px;
    font-weight: bold;
    background: #e5f4ff;
    padding: 7px 10px 7px 0px;
    .font_color {
      color: black;
    }
    .shoppingcart_ico {
      padding-left: 8px;
      position: relative;
      top: -2px;
    }
  }
  .shoppingcart_cruise {
    width: 100%;
    height: 40px;
    background: white;
    .cruise_title {
      float: left;
      padding-left: 25px;
      font-size: 14px;
      padding-top: 9px;
      width: 50%;
      line-height: 20px;
      padding-bottom: 6px;
      border-bottom: 3px solid #f2f5f8;
      span {
        font-weight: bold;
        cursor: pointer;
        vertical-align: middle;
      }
      .cruise-tab-badge {
        color: #fff;
        background-color: #ff3022;
        border-radius: 50%;
        margin-left: 4px;
        font-size: 12px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
      }
    }
    .cruise_bottom_border {
      border-bottom: 3px solid #54a3de;
    }
  }
  .shopping_cart_list {
    position: absolute;
    top: 80px;
    bottom: 40px;
    width: 100%;
    margin: 0;
    overflow-y: auto;
    font-size: 12px;
    background: white;
    padding-bottom: 30px;
  }

  .shopping_cart_isnull {
    padding: 160px 25px;
    text-align: center;
    font-size: 14px;
    position: relative;
    .link_btn {
      cursor: pointer;
    }
  }

  .totle_box {
    position: absolute;
    bottom: 40px;
    left: 0;
    right: 0;
    background: #f2f1ed;
    padding: 10px;
    .check_num {
      padding-top: 6px;
      span {
        color: #006ab9;
      }
    }
    .check_price {
      span {
        color: #ff3022;
        font-size: 20px;
        font-weight: 500;
      }
      em {
        font-style: normal;
        font-size: 12px;
      }
    }
  }

  .bottom_btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    color: #282b2c;
    background: #fbc500;
    text-align: center;
    cursor: pointer;
    font-weight: 500;
  }
}
</style>